if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        //this.cartNotification = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      buildCart(cart) {
        console.log("buildcart");
        console.log(cart.items.length);
        var ajaxCart = document.querySelector("#ajaxCart");

        if (cart.item_count > 0) {
          ajaxCart.classList.remove("empty");
        } else {
          ajaxCart.classList.add("empty");
        }

        ajaxCart.querySelector(".cart-body").innerHTML = "";

        var html = "";
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          console.log(item);
          // html += "<div class='cart-item' data-variantid='" + item.variant_id + "'>"
          //        +   "<a href='" + item.url + "' class='item-image'>"
          //        +     "<img src='" + item.featured_image.url + "'>"
          //        +   "</a>"
          //        +   "<div class='item-content'>"
          //        +     "<div class='item-row'>"
          // 	   + 		"<a href='/collections/vendors?q=" + item.vendor + "' class='item-vendor'>" + item.vendor + "</a>"
          //        +        "<span class='item-price'>" + Shopify.formatMoney(item.price) + " </span>"
          //        +     "</div>"
          //        +     "<div class='item-row'>"
          // 	   + 		"<a href='" + item.url + "' class='item-title'>" + item.product_title + "</a>"
          //        +     "</div>"
          //        +     "<div class='item-row'>"
          //        +        "<a href='" + item.url + "' class='item-variant'>" + item.title.split("-")[1] + "</a>"
          //        +     "</div>"
          //        +     "<div class='item-row'>"
          //        +       "<a class='item-wishlist'>Move to wishlist</a>"
          //        +       "<a class='item-remove'>Remove</a>"
          //        +     "</div>"
          //        +   "</div>"
          //        + "</div>";

          let preOrder = "";
          let finalSale = "";
          let shipsIn = "";

          if (item.properties && item.properties["Pre-order"]) {
            preOrder = `<div class="product-option item-variant"><dt>Pre-order: </dt><dd>${item.properties["Pre-order"]}</dd></div>`;
          }
          if (item.properties && item.properties["Ships in"]) {
            shipsIn = `<div class="product-option item-variant"><dt>Ships in: </dt><dd>${item.properties["Ships in"]}</dd></div>`;
          }

          if (item.properties && item.properties["Final Sale"]) {
            finalSale = `<div class="product-option item-variant color-fc5230">Final Sale</div>`;
          }

          let priceText = "";

          if (item.properties && item.properties["_original-price"]) {
            const compare_price = parseInt(
              item.properties["_original-price"],
              10
            );

            if (compare_price > item.price) {
              priceText = `
                <span class="ss-sale-price-off">
                  (${Math.round(
                    ((compare_price - item.price) / compare_price) * 100
                  )}% OFF)
                </span>
                <s class="ss-sale-price ss-price-trigger" data-unit-price="${compare_price}">${Shopify.formatMoney(
                compare_price * item.quantity
              )}</s>
              `;
            }
          }

          if (item.price != item.final_price) {
            priceText += `
              <span class="visually-hidden">Regular price</span>
              <s class="cart-item__old-price product-option ss-sale-price ss-price-trigger" data-unit-price="${
                item.price
              }">
                ${Shopify.formatMoney(item.price * item.quantity)}
              </s>
              <span class="ss-sale-price visually-hidden">Sale price</span>
              <span class="cart-item__final-price product-option ss-price-trigger" data-unit-price="${
                item.final_price
              }">
                ${Shopify.formatMoney(item.final_price * item.quantity)}
              </span>
            `;
          } else {
            priceText += `
              <div class="product-option ss-price-trigger" data-unit-price="${
                item.price
              }">
                ${Shopify.formatMoney(item.price * item.quantity)}
              </div>
              `;
          }

          const discountsArray = item.discounts;
          let discounts = "";

          discountsArray.forEach((element) => {
            discounts += `<span>${element.title}</span>`;
          });

          html += `
            <div class="cart-item" data-variantid="${item.variant_id}">
              <a href="${item.url}" class="item-image">
                <img src="${item.featured_image.url}">
              </a>
              <div class="item-content">
                <div class="item-content-holder">
                  <div class="item-content-left">
                    <a href="/collections/vendors?q=${
                      item.vendor
                    }" class="item-vendor">${item.vendor}</a>
                    <a href="${item.url}" class="item-title">
                      ${item.product_title}
                    </a>
                    <a href="${item.url}" class="item-variant">
                      ${item.title.split("-")[1]}
                    </a>
                    <a class="item-wishlist">Move to wishlist</a>
                    ${preOrder}
                    ${shipsIn}
                    ${finalSale}
                    <div class="ss-ajax-cart-quantity-input">
                      <quantity-input class="quantity">
                        <button class="quantity__button no-js-hidden" name="minus" type="button">
                          <span class="visually-hidden">Decrease quantity for ${
                            item.title
                          }</span>
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg>
                        </button>
                        <input
                          class="quantity__input qty-input"
                          type="number"
                          name="updates[]"
                          value="${item.quantity}"
                          min="0"
                          aria-label="Quantity for ${item.title}"
                          id="Quantity-${i + 1}"
                          data-index="${i + 1}"
                          disabled
                        >
                        <button class="quantity__button no-js-hidden" name="plus" type="button">
                          <span class="visually-hidden">Increase quantity for ${
                            item.title
                          }</span>
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>
                        </button>
                      </quantity-input>
                    </div>
                  </div>
                  <div class="item-content-right">
                    <div class="item-content-right-wrap">
                      <span class="item-price">
                        ${priceText}
                      </span>
                      <div class="ss-discount" role="list">${discounts}</div>
                    </div>
                    <div><a class="item-remove">Remove</a></div>
                  </div>
                </div>
              </div>
            </div>
          `;
        }

        ajaxCart.querySelector(".cart-body").innerHTML = html;
        ajaxCart.querySelector(".subtotal").innerHTML = Shopify.formatMoney(
          cart.items_subtotal_price
        );

        document.querySelector("body").classList.add("ajaxcart-open");

        console.log(document.querySelectorAll(".cart-count-bubble").length);
        if (document.querySelectorAll(".cart-count-bubble").length > 0) {
          document
            .querySelectorAll(".cart-count-bubble")
            .forEach(function (obj) {
              obj.innerHTML = cart.item_count;
            });
        } else {
          document
            .querySelectorAll(".header__icon--cart")
            .forEach(function (obj) {
              const bubble = document.createElement("div");
              bubble.classList.add("cart-count-bubble");
              bubble.innerHTML = cart.item_count;
              obj.append(bubble);
            });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log("Here");

        if (document.querySelector('.product-form__input[data-option="size"]'))
          if (
            !document.querySelector(
              '.product-form__input[data-option="size"] .size-buttons input[type="radio"]:checked'
            )
          ) {
            document.querySelector(
              '.product-form__input[data-option="size"] .size-label legend'
            ).innerHTML =
              '<span class="color-fc5230">Please select a size</span>';
            return;
          }

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        if (this.submitButton.classList.contains("ssJoinWaitlist")) {
          console.log("Waitlist");
          if (
            this.form.querySelector("[name=id]") &&
            this.form.querySelector("[name=id]").value
          )
            BIS.popup.show({
              variantId: this.form.querySelector("[name=id]").value,
            });
          evt.stopPropagation();
          return;
        }

        this.handleErrorMessage();
        //this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        //formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        var pform = this;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  //setTimeout(() => { this.cartNotification.renderContents(response) });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              //this.cartNotification.renderContents(response);
            }

            fetch(window.Shopify.routes.root + "cart.js")
              .then((response) => response.json())
              .then((cart) => {
                console.log(cart);
                pform.buildCart(cart);
                return cart;
              });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          if (
            document
              .querySelector("body")
              .classList.contains("template--product-gift_card")
          ) {
            console.log(errorMessage);

            const customMessages = {
              "can't be present without email": "Email field is required",
              "is too long (maximum is 200 characters)":
                "Message is too long (max 200 characters)",
              "is invalid": "Email is invalid",
            };

            const uniqueErrors = new Set();

            // Extract and simplify error messages
            for (const field in errorMessage) {
              errorMessage[field].forEach((error) => {
                uniqueErrors.add(customMessages[error] || error);
              });
            }

            // Combine all errors into a single string
            const newErrorMessage = Array.from(uniqueErrors).join("<br>");

            this.errorMessage.innerHTML = newErrorMessage;
          } else {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    }
  );
}
